var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUxers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.946 17.273a.54.54 0 0 1 .324.674c-.452 1.434-1.831 2.43-3.411 2.43a3.63 3.63 0 0 1-2.497-.98.552.552 0 0 1-.038-.754.492.492 0 0 1 .718-.04 2.639 2.639 0 0 0 1.817.707c1.187 0 2.145-.744 2.444-1.698a.504.504 0 0 1 .643-.339Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.22 8.874C4.22 4.644 7.699 1 11.986 1s7.764 3.378 7.764 7.874v.66h.153c1.726 0 3.098 1.507 3.098 3.333 0 1.825-1.372 3.333-3.098 3.333h-.174c-.298 3.768-3.673 6.8-7.743 6.8s-7.445-3.032-7.743-6.8h-.144C2.373 16.2 1 14.692 1 12.867c0-1.826 1.373-3.334 3.098-3.334h.123v-.66Zm7.765 13.06c-3.75 0-6.747-2.926-6.747-6.274h3.899c.537 0 1.057-.2 1.467-.564a2.19 2.19 0 0 1 2.933 0c.41.364.93.564 1.466.564h3.73c0 3.348-2.998 6.273-6.748 6.273ZM4.221 10.6h-.123c-1.135 0-2.08 1-2.08 2.267s.945 2.266 2.08 2.266h.123V10.6Zm15.528 4.533h.153c1.134 0 2.08-.999 2.08-2.266 0-1.268-.945-2.267-2.08-2.267h-.153v4.533Zm-9.194-4.8c0-2.264-2.687-2.264-2.687 0v.534c0 1.998 2.687 1.998 2.687 0v-.534Zm5.45 0c0-2.264-2.687-2.264-2.687 0v.534c0 1.998 2.687 1.998 2.687 0v-.534Zm-2.668-3.43c.787 0 1.159-1.02.572-1.571l-.792-.745.666-.647c.587-.57.203-1.599-.597-1.599l-1.192 1.401-1.192-1.4c-.794 0-1.173 1.024-.586 1.586l.69.66-.808.752c-.587.546-.219 1.562.566 1.562l1.33-1.462 1.342 1.462Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUxers);
export default __webpack_public_path__ + "static/media/uxers.c9e33270688481cc171fd203fc31d2c4.svg";
export { ForwardRef as ReactComponent };